// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uKtk","colMin":"styles_colMin__EkYpu"};